import React, { useEffect, useState } from 'react';
import { List, NavBar } from 'antd-mobile'

import { 
    BodyView,
    ListView
} from "../factory/ViewUtil";
import { RequestNews } from '../../NetworkFactory';
import { CellStateView } from '../factory/CellViews';
import { ToDate2 } from '../factory/FactoryUtil';

const ItemView = React.memo(({item, onClick}) => {
    return (
        <List.Item className='cellCardBorder' onClick={onClick} arrowIcon={false}>
            <div style={{display : 'flex', marginBottom : '10px'}}>
                <div style={{flex : '1'}}>{item.title}</div>
                <div style={{marginLeft : '6px', fontSize : '14px', color : "#666"}}>{ToDate2(item.creationDate)}</div>
            </div>
            <div style={{fontSize : '14px', color : 'gray'}}>{item.brief}</div>
        </List.Item>
    )
})


const MessageViewController = ({goback, navpush}) => {


    const [stateCode, setStateCode] = useState(3);
    const [dataSource, setDataSource] = useState([]);
    const requestData = () => {
        RequestNews().then(response => {
            const data = response.data.data || []
            setStateCode(data.length >0 ? -1 : 1)
            setDataSource(data)
        }).catch(()=> {
            setStateCode(1)
        })
    }

    useEffect(() => {
        requestData()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Message</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <CellStateView stateType={stateCode} onRefresh={()=>{requestData()}}/> 
                    {
                        dataSource.map((item, index) => (
                            <ItemView 
                                item={item}
                                onClick={()=>{navpush('./preview', false, item)}}
                                key={index}
                            />
                        ))
                    }
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(MessageViewController)